<template>
  <div class="manage">
    <div class="treeList">
      <el-tree :data="data" :props="defaultProps" show-checkbox @check-change="handleCheckChange"></el-tree>
    </div>
    <div class="content">
      <el-container>
        <el-header>
          <el-form :inline="true" :model="dataForm" label-width="100px">
            <el-row>
              <el-col :span="8">
                <el-form-item label="标题：">
                  <el-input v-model="dataForm.billHead" placeholder="请输入标题" clearable></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="发文字号：">
                  <el-input v-model="dataForm.billHead" placeholder="请输入发文字号" clearable></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="审批状态：">
                  <el-select v-model="dataForm.billHead" placeholder="请选择审批状态">
                    <el-option value="1">123</el-option>
                    <!--                    <el-option :label="deptItem.applyDeptName" :value="deptItem.applyDeptId" v-for="(deptItem,deptIndex) in deptList" :key="'deptItem'+deptIndex"></el-option>-->
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="16">
                <el-form-item label="发布日期：">
                  <el-date-picker
                      v-model="dataForm.approveTime"
                      @change="approveTimeChange"
                      type="daterange"
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      :default-time="['00:00:00', '23:59:59']">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="8" class="btnRight">
                <el-form-item class="btnList">
                  <el-button type="primary" @click="query()">查 询</el-button>
                  <el-button type="info" @click="reset()">重 置</el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-header>
        <el-main ref="main">
          <el-table
              ref="dataTable"
              :data="documentList"
              highlight-current-row
              @current-change="handleSelectionChange"
              @row-click="rowClicked"
              @cell-dblclick="dblclickDetail"
              size="mini"
              height="100%"
              border
          >
            <el-table-column type="index" width="50"></el-table-column>
            <el-table-column
                prop="approveCode"
                label="标题"
                :show-overflow-tooltip="true"
            ></el-table-column>
            <el-table-column
                prop="approveCode"
                label="公文类型"
                :show-overflow-tooltip="true"
            ></el-table-column>
            <el-table-column
                prop="approveCode"
                label="发文字号"
                :show-overflow-tooltip="true"
            ></el-table-column>
            <el-table-column
                prop="approveCode"
                label="发文部门"
                :show-overflow-tooltip="true"
            ></el-table-column>
            <el-table-column
                prop="approveCode"
                label="发文日期"
                :show-overflow-tooltip="true"
            ></el-table-column>
            <el-table-column
                prop="approveCode"
                label="发布日期"
                :show-overflow-tooltip="true"
            ></el-table-column>
            <el-table-column label="操作" header-align="center" align="center" width="180">
              <template slot-scope="scope">
                <el-button type="text" size="small" @click="goToDetails(scope.row)">详情</el-button>
                <el-button type="text" size="small" @click="goToDetails(scope.row)">审批</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-main>
      </el-container>
    </div>
  </div>
</template>

<script>
import documentManageAddAndModiify from "@/page/document/manage/addAndModiify";

export default {
  name: "index",
  data(){
    return {
      dataForm: {
        billHead: '',
        approveTime: [],
        approveStartTime:'',
        approveEndTime:'',
      },

      data: [
        {
          label: '一级 1',
          children: [{
            label: '二级 1-1',
            children: [{
              label: '三级 1-1-1'
            }]
          }]
        }, {
          label: '一级 2',
          children: [{
            label: '二级 2-1',
            children: [{
              label: '三级 2-1-1'
            }]
          }, {
            label: '二级 2-2',
            children: [{
              label: '三级 2-2-1'
            }]
          }]
        }, {
          label: '一级 3',
          children: [{
            label: '二级 3-1',
            children: [{
              label: '三级 3-1-1'
            }]
          }, {
            label: '二级 3-2',
            children: [{
              label: '三级 3-2-1'
            }]
          }]
        }],
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      documentList: [{}],
    }
  },
  methods:{
    handleCheckChange(data, checked, indeterminate) {
      console.log(data, checked, indeterminate);
    },
    approveTimeChange(val){
      if(val){
        this.dataForm.approveStartTime = this.dataForm.approveTime[0];
        this.dataForm.approveEndTime = this.dataForm.approveTime[1];
      }else{
        this.dataForm.approveStartTime = '';
        this.dataForm.approveEndTime = '';
      }
    },
    // 列代表多选回调
    handleSelectionChange(val) {
      this.selectItems = val;
    },
    // 点击选中行
    rowClicked(row, event, column) {
      this.$refs.dataTable.toggleRowSelection(row);
    },
    // 双击
    dblclickDetail(row, column, cell, event) {
      this.bus.$emit("navMenuChange", {
        routeId: "salesInvoiceDetail",
        routeParam: {
          approveId: row.id
        }
      });
    },
    // 去详情页
    goToDetails(item){
      this.bus.$emit("navMenuChange", {
        routeId: "incomingApprovalDetails",
        routeParam: {
          // id: item.id
        }
      });
    },
  }
}
</script>

<style scoped lang="scss">
@import "@/assets/css/commonLayout.scss";
.manage{
  height: 100%;
  display: flex;
  justify-content: space-between;
  .treeList{
    width: 15%;
    background-color: white;
    .treeItem{
      width: 100%;
      height: 50px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  .content{
    width: 83%;
    background-color: white;
  }
}
.btnRight {
  display: flex;
  justify-content: flex-end;
  .btnList{
    text-align: right;
  }
  /deep/.el-form-item__content{
    height: auto;
  }
}
</style>